<button type="button" class="ev-plain-button" id="follow-mode-button" data-testid="follow-mode-btn" (click)="followModeOnClick()">
    <img [src]="getFollowModeIcon" alt="Center Map" />
</button>